import { k2ApiRoot } from './root';

export const api = k2ApiRoot;
